import { createFileRoute, redirect } from "@tanstack/react-router";

import { legacyDestinationTarget } from "@/lib/legacy-redirects";

/**
 * Legacy paginated destination archive
 * `/tour-destination/{destination}/page/{n}/`. All pages collapse into the
 * single current listing (the app paginates client-side), avoiding soft-404s.
 */
export const Route = createFileRoute("/tour-destination/$destination/page/$page")({
  beforeLoad: ({ params }) => {
    const target = legacyDestinationTarget(params.destination);
    if (target.kind === "city") {
      throw redirect({ to: "/tours/$city", params: { city: target.city }, statusCode: 301 });
    }
    throw redirect({
      to: "/tours",
      search: target.q ? { q: target.q } : {},
      statusCode: 301,
    });
  },
});
